module.exports = __webpack_public_path__ + "img/icon_dot_orange.c1a7b261.svg";